export const unseenMessageScreenReaderOnlyText = "Yyc";
export const unseenMessagesScreenReaderOnlyText = "Zyc";
export default {unseenMessageScreenReaderOnlyText,unseenMessagesScreenReaderOnlyText};